import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SmsSendPopupComponent, SmsSendPopupComponentData } from 'src/app/communication/sms-send-popup/sms-send-popup.component';
import { Agent } from '../../../sport-activity/shared/models/agent.model';
import { Person } from '../../models/person.model';
import { Variable, VariableMap } from '../../types/common';
import { PersonsListItemActionType } from '../persons-list/persons-list.component';
import { PersonsVisualizerComponentActionCallback } from '../persons-visualizer/persons-visualizer.component';

interface PersonNormalized extends Agent {
  normalizedName;
  age: number;
}

@Component({
  selector: 'cm-person-card',
  templateUrl: './person-card.component.html',
  styleUrls: ['./person-card.component.scss'],
})
export class PersonCardComponent implements OnInit, OnChanges {
  PersonsListItemActionType = PersonsListItemActionType;

  @Input() variables: VariableMap = {};
  @Input() person: Person;
  @Input() actions: PersonsListItemActionType[] = [];
  @Input() actionsCallback: PersonsVisualizerComponentActionCallback;

  nowYear = new Date().getUTCFullYear();
  nowMonth = new Date().getUTCMonth();
  nowDate = new Date().getUTCDate();

  getAge = (birthday: Date) => {
    let baseAge = this.nowYear - birthday.getUTCFullYear();

    if (birthday.getUTCMonth() < this.nowMonth) {
      baseAge--;
    } else if (birthday.getUTCMonth() === this.nowMonth) {
      if (birthday.getUTCDate() < this.nowDate) {
        baseAge--;
      }
    }

    return baseAge;
  };

  normalizedPerson: PersonNormalized;

  constructor(private matDialog: MatDialog) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.person) {
      this.normalizedPerson = {
        ...this.person,
        normalizedName: this.getNormalizedName(this.person.name),
        age: this.person.customFields['birthday'] ? this.getAge(new Date(this.person.customFields['birthday'] as string)) : null,
      } as PersonNormalized;
    }
  }

  sendSms() {
    this.matDialog.open(SmsSendPopupComponent, {
      height: '550px',
      width: '600px',

      data: { contacts: [{ msisdn: this.person.msisdn }], variables: this.variables } as SmsSendPopupComponentData,
      panelClass: 'popup-component-pane',
    });
  }

  callAction(actionType: PersonsListItemActionType) {
    this.actionsCallback(actionType, this.person);
  }

  private getNormalizedName(name: string) {
    const names = name.normalize('NFD').split(' ');

    if (!names.length) {
      return null;
    }

    return names.length > 1 ? `${names[0]} ${names[names.length - 1]}` : names[0];
  }
}
